<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>
    <v-dialog max-width="85%" v-model="dialogMov" persistent>
      <v-card>
        <v-card-title>
          Crear Movimiento
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="movItem.id_almacen"
                outlined
                hide-details
                dense
                label="Farmacia UMM"
                :loading="loadingAlmacenes"
                :items="almacenes_usuario"
                item-text="nombre"
                item-value="id_almacen"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="movItem.id_almacen_tipo_movimiento"
                outlined
                hide-details
                dense
                label="Tipo de Movimiento"
                :loading="loadingTiposMovimientos"
                :items="tipos_movimientos"
                item-text="nombre"
                item-value="id_almacen_tipo_movimiento"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-data-table :items="movItem.medicamentos" :headers="headersMedicamentos" :items-per-page="-1" hide-default-footer>
                <template v-slot:[`item.id_medicamento`]="{ item }">
                  <v-autocomplete
                    v-model="item.id_medicamento"
                    outlined
                    label="Medicamento"
                    hide-details
                    :items="medicamentos"
                    :item-text="medicamentoNombre"
                    item-value="id_medicamento"
                    dense
                  >
                  </v-autocomplete>
                </template>
                <template v-slot:[`item.cantidad`]="{ item }">
                  <v-number-field
                    v-model="item.cantidad"
                    label="Cantidad"
                  >
                  </v-number-field>
                </template>
                <template v-slot:[`item.lote`]="{ item }">
                  <v-text-field
                    v-model="item.lote"
                    :disabled="movItem.id_almacen_tipo_movimiento != 'e733b340-06ab-43c7-b8c6-68192556c587'"
                    outlined
                    hide-details
                    dense
                    label="Lote"
                  >
                  </v-text-field>
                </template>
                <template v-slot:[`item.fecha_caducidad`]="{ item }">
                  <date-picker v-model="item.fecha_caducidad"
                    :disabled="movItem.id_almacen_tipo_movimiento != 'e733b340-06ab-43c7-b8c6-68192556c587'"
                    valueType="format"
                    format="DD-MM-YYYY"
                  ></date-picker>
                </template>
                <template  v-slot:[`item.actions`]="{ item }">
                  <v-tooltip-icon
                    icon="mdi-trash-can-outline"
                    text="Eliminar"
                    @click="delMedicine1(item)"
                  ></v-tooltip-icon>
                </template>
              </v-data-table>
              <br>
              <v-btn text class="white--text" color="blue" @click="addMedicine1">Agregar Medicamento</v-btn>
            </v-col>
            <template v-if="movItem.id_almacen_tipo_movimiento == 'e733b340-06ab-43c7-b8c6-68192556c587'">
            </template>
            <v-col cols="12">
              <v-textarea
                v-model="movItem.anotacion"
                outlined
                hide-details
                dense
                label="Anotación"
                :rows="1"
                auto-grow
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogMov">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogMov" :loading="loadingSaveMov">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="65%" v-model="dialogMovTras" persistent>
      <v-card>
        <v-card-title>
          Crear Movimiento entre Almacenes
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="movTrasItem.id_almacen_origen"
                outlined
                hide-details
                dense
                label="Farmacia UMM Origen"
                :loading="loadingAlmacenes"
                :items="almacenes_usuario"
                item-text="nombre"
                item-value="id_almacen"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="movTrasItem.id_almacen_destino"
                outlined
                hide-details
                dense
                label="Farmacia UMM Destino"
                :loading="loadingAlmacenes"
                :items="almacenes"
                item-text="nombre"
                item-value="id_almacen"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-data-table :items="movTrasItem.medicamentos" :headers="headersMedicamentos" :items-per-page="-1" hide-default-footer>
                <template v-slot:[`item.id_medicamento`]="{ item }">
                  <v-autocomplete
                    v-model="item.id_medicamento"
                    outlined
                    label="Medicamento"
                    hide-details
                    :items="medicamentos"
                    :item-text="medicamentoNombre"
                    item-value="id_medicamento"
                    dense
                  >
                  </v-autocomplete>
                </template>
                <template  v-slot:[`item.cantidad`]="{ item }">
                  <v-number-field
                    v-model="item.cantidad"
                    label="Cantidad"
                  >
                  </v-number-field>
                </template>
                <template  v-slot:[`item.actions`]="{ item }">
                  <v-tooltip-icon
                    icon="mdi-trash-can-outline"
                    text="Eliminar"
                    @click="delMedicine2(item)"
                  ></v-tooltip-icon>
                </template>
              </v-data-table>
              <br>
              <v-btn text class="white--text" color="blue" @click="addMedicine2">Agregar Medicamento</v-btn>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="movTrasItem.anotacion"
                outlined
                hide-details
                dense
                label="Anotación"
                :rows="1"
                auto-grow
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogMovTras">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogMovTras" :loading="loadingSaveMovTras">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="65%" v-model="dialogDetail" persistent>
      <v-card>
        <v-card-title>
          Detalles del Movimiento
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.almacen"
                dense
                hide-details
                outlined
                label="Farmacia UMM"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.tipo_movimiento"
                dense
                hide-details
                outlined
                label="Tipo de Movimiento"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.medicamento"
                dense
                hide-details
                outlined
                label="Medicamento"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.cantidad"
                dense
                hide-details
                outlined
                label="Cantidad"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.usuario_asigno"
                dense
                hide-details
                outlined
                label="Usuario Asigno"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.fecha_asigno"
                dense
                hide-details
                outlined
                label="Fecha de Asignación"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.usuario_completo"
                dense
                hide-details
                outlined
                label="Usuario Confirmo Movimiento"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailItem.fecha_completo"
                dense
                hide-details
                outlined
                label="Fecha Confirmo Movimiento"
                readonly
              >
              </v-text-field>
            </v-col>
            <!--
            <v-col cols="4">
              <v-text-field
                v-model="detailItem.motivo_rechazo"
                dense
                hide-details
                outlined
                label="Motivo de Rechazo"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="detailItem.usuario_rechazo"
                dense
                hide-details
                outlined
                label="Usuario Rechazo"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="detailItem.fecha_rechazo"
                dense
                hide-details
                outlined
                label="Fecha de Rechazo"
                readonly
              >
              </v-text-field>
            </v-col>
            -->
            <v-col cols="6" v-if="detailItem.lote != null">
              <v-text-field
                v-model="detailItem.lote"
                dense
                hide-details
                outlined
                label="Lote"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" v-if="detailItem.fecha_caducidad != null">
              <v-text-field
                v-model="detailItem.fecha_caducidad"
                dense
                hide-details
                outlined
                label="Lote"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="detailItem.anotacion"
                dense
                hide-details
                outlined
                label="Anotación"
                :rows="1"
                auto-grow
                readonly
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDetails">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="65%" v-model="dialogCargaMasiva" persistent>
      <v-card>
        <v-card-title>
          Ajuste Masivo de Almacén
        </v-card-title>
        <v-card-text>
          <v-row>
            
            <v-col cols="12">
              Esta carga masiva permite que, por medio de un archivo CSV, pueda actualizar el stock de su almacén de manera rápida y eficiente. Solo tiene que subir el archivo con los datos de stock actualizados, y el sistema ajustará automáticamente los niveles de inventario para que coincidan con los valores del archivo. Así, siempre tendrá sus datos de inventario al día sin complicaciones.
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn text color="primary" @click="nuevaPestana(`/api/Almacenes/DescargarMedicamentos?jwt=${token}`)">
                <v-icon>
                  mdi-download
                </v-icon>
                Descargar Formato Carga
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="cargaMasivaItem.id_almacen"
                outlined
                hide-details
                dense
                label="Farmacia UMM"
                :loading="loadingAlmacenes"
                :items="almacenes_usuario"
                item-text="nombre"
                item-value="id_almacen"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-file-input
                v-model="cargaMasivaItem.archivo"
                label="Archivo CSV"
                accept=".csv"
                prepend-icon="mdi-upload"
                outlined
                dense
                hide-details
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="cerrarCargaMasiva">Cerrar</v-btn>
          <v-btn color="red" text @click="guardarCargaMasiva">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="6">
        <v-row class="ma-0 pa-0">
          <v-col cols="6" class="ma-0 pa-0">
            <v-btn color="primary" @click="openDialogMov">Crear Movimiento</v-btn>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-btn color="primary" @click="openDialogMovTras">Crear Movimiento Entre Almacenes</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        
      </v-col>
      <v-col cols="2" style="text-align: right;">
        <v-btn text color="primary" @click="openCargaMasiva">
          Carga Masiva
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          v-model="busquedaItem.id_almacen"
          outlined
          hide-details
          dense
          label="Farmacia UMM"
          :loading="loadingAlmacenes"
          :items="almacenes_usuario"
          item-text="nombre"
          item-value="id_almacen"
          clearable
          @change="getItems(true)"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          v-model="busquedaItem.id_almacen_tipo_movimiento"
          outlined
          hide-details
          dense
          label="Tipo de Movimiento"
          :loading="loadingTiposMovimientos"
          :items="tipos_movimientos"
          item-text="nombre"
          item-value="id_almacen_tipo_movimiento"
          clearable
          @change="getItems(true)"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          v-model="busquedaItem.id_medicamento"
          outlined
          label="Medicamento"
          hide-details
          :items="medicamentos"
          :item-text="medicamentoNombre"
          item-value="id_medicamento"
          dense
          clearable
          @change="getItems(true)"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        Rango de Fechas: 
        <date-picker v-model="busquedaItem.rango" range valueType="format" format="DD-MM-YYYY" @change="getItems(true)"></date-picker>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          @update:page="getItems(false)"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:[`item.servicio`]="{ item }">
            {{ (item.servicio != null) ? item.servicio : "N/A" }}
          </template>
          <template v-slot:[`item.completado`]="{ item }">
            {{ (item.completado) ? 'Completado' : 'Por Entregar' }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogDetails(item)">mdi-eye</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import { mapState } from 'vuex'
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';
import VNumberField from '@/components/VNumberField.vue'

export default {
  components: {
    VAlertDialog,
    VNumberField,
    DatePicker
  },
  data: () => ({
    
    loading: false,
    
    totalRecords: 0,
    page: 1,
    itemsPerPage: 10,
    
    items: [],
    headers: [
      { text: "Farmacia UMM", value: "almacen", align: "center", width: "20%" },
      { text: "Tipo Movimiento", value: "tipo_movimiento", align: "center", width: "15%" },
      { text: "Cantidad", value: "cantidad", align: "center", width: "15%" },
      { text: "Medicamento", value: "medicamento", align: "center", width: "20%" },
      { text: "Servicio", value: "servicio", align: "center", width: "15%" },
      { text: "Estatus", value: 'completado', align: 'center', width: "15%" },
      { text: "Acciones", value: "actions", align: "center", width: "10%" }
    ],
    dialogDetail: false,
    detailItem: {
      almacen: null,
      tipo_movimiento: null,
      medicamento: null,
      cantidad: null,
      usuario_asigno: null,
      fecha_asigno: null,
      usuario_completo: null,
      fecha_completo: null,
      motivo_rechazo: null,
      usuario_rechazo: null,
      fecha_rechazo: null,
      anotacion: null,
    },
    defaultDetailItem: {
      almacen: null,
      tipo_movimiento: null,
      medicamento: null,
      cantidad: null,
      usuario_asigno: null,
      fecha_asigno: null,
      usuario_completo: null,
      fecha_completo: null,
      motivo_rechazo: null,
      usuario_rechazo: null,
      fecha_rechazo: null,
      anotacion: null,
    },

    defaultMedicamento: {
      id_medicamento: null,
      cantidad: 1,
      fecha_caducidad: null,
      lote: null
    },
    headersMedicamentos: [
      { text: "Medicamento", value: "id_medicamento", align: "center", width: "25%" },
      { text: "Cantidad", value: "cantidad", align: "center", width: "25%" },
      { text: "Lote", value: "lote", align: "center", width: "20%" },
      { text: "Fecha de Caducidad", value: "fecha_caducidad", align: "center", width: "20%" },
      { text: "Acciones", value: "actions", align: "center", width: "10%" }
    ],
    busquedaItem: {
      id_almacen: null,
      id_almacen_tipo_movimiento: null,
      id_medicamento: null,
      rango: null
    },


    dialogMov: false,
    loadingSaveMov: false,
    movItem: {
      id_almacen: null,
      id_almacen_tipo_movimiento: null,
      medicamentos: [],
      anotacion: null
    },
    defaultMovItem: {
      id_almacen: null,
      id_almacen_tipo_movimiento: null,
      medicamentos: [],
      anotacion: null
    },
    dialogMovTras: false,
    loadingSaveMovTras: false,
    movTrasItem: {
      id_almacen_origen: null,
      id_almacen_destino: null,
      medicamentos: [],
      anotacion: null
    },
    defaultMovTrasItem: {
      id_almacen_origen: null,
      id_almacen_destino: null,
      medicamentos: [],
      anotacion: null
    },
    loadingAlmacenes: false,
    almacenes: [],
    almacenes_usuario: [],
    loadingTiposMovimientos: false,
    tipos_movimientos: [],
    loadingMedicamentos: false,
    medicamentos: [],
    dialogCargaMasiva: false,
    cargaMasivaItem: {
      id_almacen: null,
      archivo: null
    },
    defaultCargaMasivaItem: {
      id_almacen: null,
      archivo: null
    }
  }),
  computed: {
    ...mapState(['id_unidad_medica_activa', 'token'])
  },
  mounted() {
    this.getItems();
    this.getAlmacenes();
    this.getAlmacenesUsuario();
    this.getTiposMovimientos();
    this.getMedicamentos();
  },
  methods: {
    medicamentoNombre: medicamento => `[${medicamento.codigo}] - ${medicamento.farmaco} ${medicamento.concentracion} - ${medicamento.presentacion}`,
    getMedicamentos(){
      this.loadingMedicamentos = true;
      axios
        .get('/Catalogos/ListarMedicamentos')
        .then(response => {
          this.medicamentos = response.data;
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loadingMedicamentos = false;
        })
    },
    getTiposMovimientos() {
      this.loadingTiposMovimientos = true;
      axios.get('/Almacenes/ListarTiposMovimiento')
        .then(response => {
          this.tipos_movimientos = response.data.filter(x => x.id_almacen_tipo_movimiento != "04f37992-2e45-4a01-b4aa-30ab58081830");
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingTiposMovimientos = false;
        })
    },
    getAlmacenesUsuario() {
      this.loadingAlmacenes = true;
      axios.get('/Almacenes/ListarAlmacenesUsuario')
        .then(response => {
          this.almacenes_usuario = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingAlmacenes = false;
        })
    },
    getAlmacenes() {
      //this.loadingAlmacenes = true;
      axios.get('/Almacenes/ListarAlmacenes')
        .then(response => {
          this.almacenes = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          //this.loadingAlmacenes = false;
        })
    },
    onItemsPerPageChange(value){
      this.page = 1;
      this.itemsPerPage = value;
      this.getItems();
    },
    getItems(reset = false) {
      if(reset === true) this.page = 1;

      const url = new URL(`http://localhost/Almacenes/ListarMovimientos`);
      url.searchParams.append("page", this.page);
      url.searchParams.append("size", this.itemsPerPage);
      if(this.busquedaItem.id_almacen != null) url.searchParams.append("id_almacen", this.busquedaItem.id_almacen);
      if(this.busquedaItem.id_almacen_tipo_movimiento != null) url.searchParams.append("id_almacen_tipo_movimiento", this.busquedaItem.id_almacen_tipo_movimiento);
      if(this.busquedaItem.id_medicamento) url.searchParams.append("id_medicamento", this.busquedaItem.id_medicamento);
      if(this.busquedaItem.rango != null && this.busquedaItem.rango.length == 2) {
        if(this.busquedaItem.rango[0] != null) url.searchParams.append("desde", this.busquedaItem.rango[0]);
        if(this.busquedaItem.rango[1] != null) url.searchParams.append("hasta", this.busquedaItem.rango[1]);
      }
      var url_string = url.href.replace('http://localhost', '');

      this.loading = true;
      axios.get(url_string)
        .then(response => {
          this.items = response.data.results;
          this.totalRecords = response.data.total_records;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    openDialogDetails(item){
      this.detailItem = item;
      this.dialogDetail = true;
    },
    closeDialogDetails(){
      this.detailItem = Object.assign({}, this.defaultDetailItem);
      this.dialogDetail = false;
    },
    openDialogMov(){
      this.dialogMov = true;
      this.loadingSaveMov = false;
      this.movItem = Object.assign({}, this.defaultMovItem);
      this.movItem.medicamentos = [];
    },
    closeDialogMov(){
      this.dialogMov = false;
      this.loadingSaveMov = false;
      this.movItem.medicamentos = [];
      this.movItem = Object.assign({}, this.defaultMovItem);
    },
    saveDialogMov(){
      this.loadingSaveMov = true;
      axios
      .post('/Almacenes/CrearMovimiento', this.movItem)
      .then(() => {
        this.closeDialogMov();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingSaveMov = false;
      })
    },
    addMedicine1(){
      this.movItem.medicamentos.push(Object.assign({}, this.defaultMedicamento));
    },
    delMedicine1(item){
      this.movItem.medicamentos = this.movItem.medicamentos.filter(x => x != item);
    },
    openDialogMovTras(){
      this.dialogMovTras = true;
      this.loadingSaveMovTras = false;
      this.movTrasItem = Object.assign({}, this.defaultMovTrasItem);
    },
    closeDialogMovTras(){
      this.dialogMovTras = false;
      this.loadingSaveMovTras = false;
      this.movTrasItem = Object.assign({}, this.defaultMovTrasItem);
      this.movTrasItem.medicamentos = [];
    },
    saveDialogMovTras(){
      this.loadingSaveMovTras = true;
      axios
      .post('/Almacenes/CrearMovimientoTraspaso', this.movTrasItem)
      .then(() => {
        this.closeDialogMovTras();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingSaveMovTras = false;
      })
    },
    addMedicine2(){
      this.movTrasItem.medicamentos.push(Object.assign({}, this.defaultMedicamento));
    },
    delMedicine2(item){
      this.movTrasItem.medicamentos = this.movTrasItem.medicamentos.filter(x => x != item);
    },
    nuevaPestana(url) {
      window.open(url, '_blank');
    },
    openCargaMasiva(){
      this.dialogCargaMasiva = true;
    },
    cerrarCargaMasiva(){
      this.dialogCargaMasiva = false;
      this.cargaMasivaItem = Object.assign({}, this.defaultCargaMasivaItem);
    },
    guardarCargaMasiva(){
      if(this.cargaMasivaItem.id_almacen == null){
        this.$refs.alert.setMessage('', `Debe de indicar un Almacén`);
        this.$refs.alert.open();
        return;
      }

      if(this.cargaMasivaItem.archivo == null){
        this.$refs.alert.setMessage('', `Debe de indicar un Archivo de Actualización`);
        this.$refs.alert.open();
        return;
      }

      const formData = new FormData();
      formData.append('fichero', this.cargaMasivaItem.archivo);

      axios.post(`/Almacenes/MasiveUpload/${this.cargaMasivaItem.id_almacen}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        this.cerrarCargaMasiva();
        this.getItems();
      })
      .catch(error => {
        console.log(error);
      });
    }
  }
}
</script>
